import React, { useState, useContext, useEffect } from 'react';
import { ClientContext } from '../../../contexts/clientProvider';
import { AnexosContext } from '../../../contexts/anexosProvider';
import { UserContext } from '../../../contexts/userProvider';
import { anexosCadastro, cadastroComponentMap, anexosLinhas, linhasComponentMap } from '../../General/Format/anexo';
import { BiTrash } from 'react-icons/bi';
import BaseSelect from '../../General/FormsComp/Select/BaseSelect';
import BaseButton from '../../General/FormsComp/Button/BaseButton';

const Cadastro = ({ onTabChange }) => {
    const { user, setAlert } = useContext(UserContext);
    const { clientes } = useContext(ClientContext);
    const { userId, createAnexo } = useContext(AnexosContext);
    const [anexoData, setAnexoData] = useState({});
    const [linhas, setLinhas] = useState([]);
    const [clients, setClients] = useState(null);
    const [loading, setLoading] = useState(false);
    const [selectedClient, setSelectedClient] = useState("");

    useEffect(() => {
        setClients(clientes || []);
    }, [clientes]);

    const handleSelectClient = (e) => {
        const value = e.target.value;
        setSelectedClient(value);
        setAnexoData((prevData) => ({ ...prevData, id_cliente: value }));
    };

    const handleInputChangeAnexo = (e) => {
        setAnexoData((prevData) => ({ ...prevData, [e.target.name]: e.target.value }));
    };

    const handleInputChangeLinha = (e, index) => {
        const updatedLinhas = [...linhas];
        updatedLinhas[index] = { ...updatedLinhas[index], [e.target.name]: e.target.value };
        setLinhas(updatedLinhas);
    };

    const handleAddLinha = () => {
        const newLine = { id_cliente: anexoData.id_cliente, id_user: userId, created_at: new Date().toISOString().slice(0, 19).replace('T', ' '), updated_at: new Date().toISOString().slice(0, 19).replace('T', ' ') };
        setLinhas([...linhas, newLine]);
    };

    const handleRemoveLinha = (index) => setLinhas([...linhas.slice(0, index), ...linhas.slice(index + 1)]);

    const handleSaveClick = async () => {
        if (!anexoData.id_cliente) {
            setAlert({ visible: true, title: "Atenção!", placeholder: 'Preencha todos os campos obrigatórios.', confirm: false, type: "warning" });
            return;
        }
        setLoading(true);
        anexoData.telefone = linhas[0]?.linha;
        anexoData.id_usuario = userId;
        anexoData.usuario = user.nome;
        anexoData.created_at = anexoData.updated_at = new Date().toISOString().slice(0, 19).replace('T', ' ');
        anexoData.ativo = '1';
        const anexo = await createAnexo(anexoData, linhas);
        setLoading(false);
        if (anexo) {
            setAnexoData({});
            setLinhas([]);
            setSelectedClient("");
            onTabChange('consulta');
        }
    };

    const dadosAnexo = anexosCadastro(anexoData);
    const componentMapAnexo = cadastroComponentMap(handleInputChangeAnexo);
    const componentMapLinhas = linhasComponentMap(handleInputChangeLinha);

    return (
        <div className='space-y-6'>
            <div className='max-w-md'>
                <BaseSelect
                    label="Cliente"
                    name="cliente"
                    value={selectedClient}
                    onChange={handleSelectClient}
                    options={clients ? clients.slice().sort((a, b) => a.nome.localeCompare(b.nome)) : []}
                    placeholder="Selecione o cliente"
                    valueKey="id"
                    labelKey="nome"
                    required
                />
            </div>
            
            {anexoData.id_cliente && (
                <div className='space-y-6'>
                    <div className='bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-6'>
                        <h3 className='text-lg font-semibold text-gray-900 dark:text-white mb-4'>
                            Informações do Anexo
                        </h3>
                        <div className='form-container'>
                            {dadosAnexo.map((dado, index) => (
                                <div className='form-group' key={index}>{componentMapAnexo['Cadastro'](dado)}</div>
                            ))}
                        </div>
                    </div>
                    
                    <div className='bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-6'>
                        <div className='flex items-center justify-between mb-4'>
                            <h3 className='text-lg font-semibold text-gray-900 dark:text-white'>
                                Linhas Telefônicas
                            </h3>
                            <BaseButton onClick={handleAddLinha} variant="secondary" size="md">
                                Adicionar linha
                            </BaseButton>
                        </div>
                        
                        {linhas.length === 0 && (
                            <div className='text-center py-8 text-gray-500 dark:text-gray-400'>
                                Nenhuma linha adicionada ainda
                            </div>
                        )}
                        
                        {linhas.map((linha, index) => (
                            <div className="form-linhas-wrapper" key={index}>
                                <div className='form-container-linhas'>
                                    {anexosLinhas(linha).map((dado, subIndex) => (
                                        <div className='form-group-linhas' key={subIndex}>
                                            {componentMapLinhas['Linhas']({ ...dado, index })}
                                        </div>
                                    ))}
                                </div>
                                <BiTrash className='form-linhas-icon' onClick={() => handleRemoveLinha(index)} />
                            </div>
                        ))}
                    </div>
                    
                    <BaseButton 
                        onClick={handleSaveClick} 
                        disabled={loading}
                        loading={loading}
                        variant="primary" 
                        size="lg"
                        fullWidth
                    >
                        Salvar Anexo
                    </BaseButton>
                </div>
            )}
        </div>
    );
};

export default Cadastro;
